// extracted by mini-css-extract-plugin
export default {"imgdiv":"b4654657f2 _672e47388d","img":"_9ff9897160 _80c7346ea8"};